import myApi from "@/api/api";

const PriceListStore = {
  namespaced: true,
  state() {
    return {
      materials: {},
      thicknesses: {},
      units: {},
      price_list: {},
    }
  },
  mutations: {
    setMaterials(state, payload) {
      state.materials = payload.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});
    },
    setThicknesses(state, payload) {
      state.thicknesses = payload.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});
    },
    setUnits(state, payload) {
      state.units = payload.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});
    },
    setPriceList(state, payload) {
      state.price_list = payload.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});
    }
  },
  actions: {
    async loadMaterials(context) {
      const materials = await myApi.listMaterial();
      materials ? context.commit('setMaterials', materials) : context.commit('setMaterials', []);
    },
    async loadThicknesses(context) {
      const thicknesses = await myApi.listThickness();
      thicknesses ? context.commit('setThicknesses', thicknesses) : context.commit('setThicknesses', []);
    },
    async loadUnits(context) {
      const units = await myApi.listUnits();
      units ? context.commit('setUnits', units) : context.commit('setUnits', []);
    },
    async loadPriceList(context) {
      const priceList = await myApi.listPriceList();
      priceList ? context.commit('setPriceList', priceList) : context.commit('setPriceList', []);
    },
    async loadAllLists(context) {
      await Promise.all([
        context.dispatch('loadMaterials'),
        context.dispatch('loadThicknesses'),
        context.dispatch('loadUnits'),
        context.dispatch('loadPriceList')])
    }
  },
  getters: {
    getMaterialById: (state) => (id) => {
      return state.materials[id] || null;
    },
    getThicknessById: (state) => (id) => {
      return state.thicknesses[id] || null;
    },
    getUnitById: (state) => (id) => {
      return state.units[id] || null;
    },
    getPriceListById: (state) => (id) => {
      return state.price_list[id] || null;
    },
    getAllMaterials: (state) => {
      return state.materials;
    },
    getAllThicknesses: (state) => {
      return state.thicknesses;
    },
    getAllUnits: (state) => {
      return state.units;
    },
    getAllPriceList: (state) => {
      return state.price_list;
    }
  }
}

export default PriceListStore;


